import { useState } from "react";
import { Link } from "wouter";
import { useAuth } from "../context/AuthContext.jsx";
import { IllustrationCompass } from "../components/illustrations.jsx";
import { useSearch } from "wouter";

export default function Signup() {
  const { signup, error } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [inviteCode, setInviteCode] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const search = useSearch();
  const ref = new URLSearchParams(search).get("ref");

  async function onSubmit(e) {
    e.preventDefault();
    setSubmitting(true);
    await signup(email, password, inviteCode);
    setSubmitting(false);
  }

  return (
    <div className="page" style={{ maxWidth: 400, paddingTop: "18vh" }}>
      <div className="kicker" style={{ marginBottom: 28 }}>
        <span className="the-line" />
        CONQUEST
      </div>
      <div className="illustration-hero-wrap">
        <IllustrationCompass className="illustration-hero" />
      </div>

      <h1 style={{ marginBottom: 8 }}>Create your account</h1>
      <p style={{ color: "var(--muted)", fontSize: 13.5, marginBottom: ref === "share" ? 16 : 32 }}>
        Conquest is joined by invitation.
      </p>
      {ref === "share" && (
        <p style={{ fontSize: 13.5, color: "var(--bone)", background: "var(--surface-raised)", border: "1px solid var(--hairline)", borderRadius: 4, padding: "10px 14px", marginBottom: 32 }}>
          You are signing up after viewing a shared page. Enter your invite code to get started.
        </p>
      )}
      <form onSubmit={onSubmit} style={{ display: "flex", flexDirection: "column", gap: 14 }}>
        <input
          type="text"
          placeholder="Invite code"
          value={inviteCode}
          onChange={(e) => setInviteCode(e.target.value)}
          autoComplete="off"
          required
        />
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          autoComplete="email"
          required
        />
        <input
          type="password"
          placeholder="Password (min. 8 characters)"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          autoComplete="new-password"
          minLength={8}
          required
        />
        {error && <div style={{ color: "var(--error)", fontSize: 13.5 }}>{error}</div>}
        <button className="btn-primary" type="submit" disabled={submitting} style={{ marginTop: 8 }}>
          {submitting ? "Creating account…" : "Create account"}
        </button>
      </form>
      <div style={{ marginTop: 20, fontSize: 13.5 }}>
        Already have an account? <Link href="/login">Sign in</Link>
      </div>
    </div>
  );
}
